import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import UIComponent from './uiComponent';
import UIText from './uiText';
function UILabelComponent(props) {
    return (_jsxs("div", { style: { display: 'flex', ...props.styling }, children: [_jsx("label", { style: {
                    marginRight: '8px',
                    whiteSpace: 'nowrap',
                    textAlign: 'left',
                }, children: props.title }), props.text && (_jsx(Popover, { content: props.text, trigger: "click", overlayStyle: { width: 300, height: 120 }, children: _jsx(InfoCircleOutlined, { style: { cursor: 'pointer' } }) }))] }));
}
export default class UILabel extends UIComponent {
    title;
    text;
    style;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        if ('text' in s) {
            this.text = new UIText(s);
        }
        this.style = this.getProperty('style', '');
    }
    getComponent() {
        const text = this.text !== undefined ? this.text.getComponent() : null;
        const props = {
            title: this.title,
            text: text,
            styling: this.style,
        };
        return _jsx(UILabelComponent, { ...props });
    }
}
//# sourceMappingURL=uiLabel.js.map